module.exports = __webpack_public_path__ + "img/q4_sp.cc0cd332.svg";